import { render } from "./CollectionByBranchReport.vue?vue&type=template&id=6908ba54&scoped=true"
import script from "./CollectionByBranchReport.vue?vue&type=script&lang=js"
export * from "./CollectionByBranchReport.vue?vue&type=script&lang=js"

import "./CollectionByBranchReport.vue?vue&type=style&index=0&id=6908ba54&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6908ba54"]])

export default __exports__